<section>
  <div class="notifications-menu-header">
    <p><span>{{'NOTIFICATIONS.NOTIFICATIONS_TITLE' | translate}}</span></p>
    <button (click)="closeNotificationCenter()"><app-svg-icon [icon]="IconsConstants.CLOSE_ICON"></app-svg-icon></button>
  </div>
  <div class="notification-container" (scroll)="onScrollNotificationMenu($event)">
      <ng-container *ngIf="notificationsList?.length > 0; else empty;">
        <ng-container *ngFor="let notification of notificationsList">
          <div class="notification" [attr.isRead]="notification.isRead ? 'read' : ''"
            (click)="markNotificationAsRead($event, notification)">
            <div class="notification-title">
              <span>{{notification.title}}</span>
            </div>
            <div class="notification-body">
              <span>{{notification.body}}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #empty>
        <p class="empty-notification">{{'NOTIFICATIONS.EMPTY' | translate}}</p>
      </ng-template>
      <div class="loading-overlay" *ngIf="loading">
        <app-spinner [size]="SpinnerSize.ULTRA_SMALL"></app-spinner>
      </div>
  </div>
</section>